import axiosPost from '../axiosPost';

export const estadosDeRegistroUpd = async (arg) => {
    const { id, nombre, codigo, version } = arg;

    const body = {
        "service": "EstadoDeRegistroUpd",
        "params": {
            'estadoDeRegistroId': id,
            "estadoDeRegistroNombre": nombre,
            "estadoDeRegistroCod": codigo,
            "estadoDeRegistroVersion": version
        }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
};